/**
 * @generated SignedSource<<24cc670d84d4f04fe3acf6a4124fcf32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RequestReservationInput = {
  assetTags: ReadonlyArray<any>;
  clientMutationId?: string | null | undefined;
  endOn: any;
  notes?: string | null | undefined;
  phone?: string | null | undefined;
  startOn: any;
};
export type BookPageRequestMutation$variables = {
  input: RequestReservationInput;
};
export type BookPageRequestMutation$data = {
  readonly requestReservation: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type BookPageRequestMutation = {
  response: BookPageRequestMutation$data;
  variables: BookPageRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestReservationPayload",
    "kind": "LinkedField",
    "name": "requestReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookPageRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookPageRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8695168d1b1d5309e7b399c5ded69ad1",
    "id": null,
    "metadata": {},
    "name": "BookPageRequestMutation",
    "operationKind": "mutation",
    "text": "mutation BookPageRequestMutation(\n  $input: RequestReservationInput!\n) {\n  requestReservation(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "24c31b098b7dae80e59e150f372c8e2c";

export default node;
